import { render, staticRenderFns } from "./bidDocumentDetail.vue?vue&type=template&id=da1d8d5a&scoped=true"
import script from "./bidDocumentDetail.vue?vue&type=script&lang=js"
export * from "./bidDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./bidDocumentDetail.vue?vue&type=style&index=0&id=da1d8d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d8d5a",
  null
  
)

export default component.exports